module.exports = __webpack_public_path__ + "static/media/icon-mail--multiple_blue.fcbf0060.svg";